import { Header, Page, Toolbox } from 'redesign';
import { FilterButton } from 'ogp/components/views/administration/shared';
import { useToggle } from 'shared/hooks';
import { usePaymentsPage } from './hooks/use-payments-filters';
import { PaymentsTableDataProvider } from './payments-table';

export const Payments = () => {
  const { filters, setFilters, selectedFilterCount } = usePaymentsPage();
  const { on, toggle: toggleFilters } = useToggle();
  return (
    <Page
      header={<Header titleText="Betalingen" />}
      toolbox={
        <Toolbox>
          <Toolbox.PushRight>
            <FilterButton onClick={toggleFilters} nrOfActiveFilters={selectedFilterCount} />
          </Toolbox.PushRight>
        </Toolbox>
      }
    >
      <PaymentsTableDataProvider
        setFilters={setFilters}
        appliedFilters={filters}
        areFiltersOpen={on}
        toggleFilters={toggleFilters}
      />
    </Page>
  );
};
